export default __webpack_public_path__ + "static/media/sc-mp-active-ico.b0e3f25a.svg";